module.exports = __webpack_public_path__ + "img/28_BF6_dont_know_your_place.7f0504fa.jpg";